import { LOCAL_STORAGE } from 'app/localStorageManager'

/**
 * Clear the account-related local storage caches
 */
const clearLocalStorageCache = () => {
  localStorage.removeItem(LOCAL_STORAGE.lastWalletCache)
  localStorage.removeItem(LOCAL_STORAGE.signatureCache)
  localStorage.removeItem(LOCAL_STORAGE.signatureMessageCache)
  localStorage.removeItem(LOCAL_STORAGE.userTokenCache)
}

export default clearLocalStorageCache
